import React from 'react';
import { Col } from 'antd';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

import { withAppContext } from 'contexts/AppContext/AppContext';
import { getLoginRoute } from 'utils/routes';

import placeHolderImage from './images/404.svg';

import { ErrorContainer, ErrorSubtitle, ErrorTitle, Image, MainContainer, StyledCol, StyledRow } from './NotFound404.styles';

const NotFound404 = ({ onLogout }) => {
  return (
    <>
      <Helmet>
        <title>404 - Page Not Found</title>
      </Helmet>
      <MainContainer>
        <StyledRow type="flex" align="middle">
          <StyledCol span={24} md={10}>
            <Image src={placeHolderImage} alt="not-found-page" />
          </StyledCol>
          <Col span={0} md={1} />
          <StyledCol span={24} md={11}>
            <ErrorContainer>
              <ErrorTitle>404 Oops!</ErrorTitle>
              <ErrorSubtitle>
                Looks like the page you are looking for does not exist. Please return to previous page or{' '}
                <Link onClick={onLogout} to={getLoginRoute().path}>
                  try to log in again
                </Link>
                .
              </ErrorSubtitle>
            </ErrorContainer>
          </StyledCol>
        </StyledRow>
      </MainContainer>
    </>
  );
};

export default withAppContext(NotFound404);
